module.exports = __webpack_public_path__ + "img/kristina-n-berge_v2.422d3f5a.png";